export default __webpack_public_path__ + "media/images/logo-fb23030d0084009704af4f33dbf716b6.png";